<template>
  <div class="loyalty-reward-levels-container container">
    <h4 class="heading">Reward Levels</h4>
    <div class="text">
      <p>
        Every time you shop you’ll earn points on your account - and, as you
        grow your balance, you’ll unlock earlier priority access, more benefits
        and upgrade your V.I.P. status through the levels.
      </p>
    </div>
    <h5 class="sub-heading">{{ poundsToPoints }}</h5>
    <LoyaltyLevels
      v-for="(level, index) in loyaltyTiers.tiers"
      :key="index"
      :level="level"
    />
    <div class="sign-up-button">
      <Button
        type="button"
        full-width
        theme="outline"
        @click="setSlideSignUp(true)"
      >
        SIGN UP TO MEMBERS ONLY
      </Button>
    </div>
  </div>
</template>

<script>
import Button from "@/components/Button.vue";
import LoyaltyLevels from "./LoyaltyLevels.vue";
import loyaltyTiersContent from "@/assets/json/loyalty-tiers.json";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "LoyaltyRewardLevels",
  components: {
    Button,
    LoyaltyLevels,
  },
  data() {
    return {
      loyaltyTiers: loyaltyTiersContent,
    };
  },
  computed: {
    ...mapGetters("app", ["currencyCode"]),
    poundsToPoints() {
      if (!this.currencyCode) {
        return;
      }

      return (
        this.$filters.toCurrency(1, this.currencyCode, 0, 0) + " = 1 POINT"
      );
    },
  },
  methods: {
    ...mapActions("app", ["setSlideSignUp"]),
  },
};
</script>

<style lang="scss" scoped>
.loyalty-reward-levels-container {
  padding-bottom: 20px;

  @include respond-above(md) {
    padding-bottom: 120px;
  }
}

.heading {
  font-family: $heading-font-family;
  font-size: 28px;
  font-weight: 400;
  margin-bottom: 10px;
  text-align: center;
  text-transform: uppercase;
  @include respond-above(md) {
    font-size: 50px;
    margin-bottom: 20px;
  }
}

.text {
  font-family: $body-font-family;
  font-size: 13px;
  font-weight: 400;
  margin: 0 0 20px;
  text-align: center;
  @include respond-above(md) {
    max-width: 452px;
    margin: 0 auto 60px;
  }
}

.sub-heading {
  font-family: $body-font-family;
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 60px;
  text-align: center;
  @include respond-above(md) {
    font-size: 40px;
  }
}

.sign-up-button {
  display: none;
  @include respond-above(md) {
    display: block;
    width: 300px;
    margin: 40px auto 0;
  }
}
</style>
